import { useQuery } from 'react-query';

import { QueryEntity } from '../types';
import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig from '@/api/useGetFetchConfig';

interface FieldChoicesResponse {
  choices: string[];
}

interface UseGetRelativityFieldChoicesOptions {
  workspaceId: number | null;
  fieldArtifactId: number | null;
  enabled?: boolean;
}

const useGetRelativityFieldChoices = (options: UseGetRelativityFieldChoicesOptions) => {
  const { workspaceId, fieldArtifactId, enabled = true } = options;
  const { fetchConfigGET } = useGetFetchConfig();

  const getFieldChoices = async (): Promise<FieldChoicesResponse> => {
    if (!workspaceId || !fieldArtifactId) {
      throw new Error('Workspace ID and Field Artifact ID are required');
    }

    const url = `${APIBaseChronos}/api/relativity-mappings/workspaces/${workspaceId}/fields/${fieldArtifactId}/choices`;
    const response = await fetch(url, fetchConfigGET);

    if (!response.ok) {
      throw new Error(`Failed to fetch field choices: ${response.status} ${response.statusText}`);
    }

    return response.json();
  };

  return useQuery([QueryEntity.RelativityFieldChoices, workspaceId, fieldArtifactId], getFieldChoices, {
    enabled: enabled && workspaceId !== null && fieldArtifactId !== null,
    refetchOnWindowFocus: false,
    retry: (failureCount, error) => {
      if (error instanceof Error && (error.message.includes('401') || error.message.includes('403'))) {
        return false;
      }
      return failureCount < 2;
    },
  });
};

export default useGetRelativityFieldChoices;
